import { LineChart } from '@mui/x-charts/LineChart';
import ChartCard from '../../analytics/ChartCard';
import { CacheHitRateDataPoint } from '../../../../types/admin';

interface CacheHitRateChartProps {
  data: CacheHitRateDataPoint[];
  loading?: boolean;
}

export default function CacheHitRateChart({ data, loading }: CacheHitRateChartProps) {
  const timestamps = data.map((d) => new Date(d.timestamp));
  const hitRates = data.map((d) => d.hit_rate);
  const r2HitRates = data.map((d) => d.r2_hit_rate);
  const kvHitRates = data.map((d) => d.kv_hit_rate);

  return (
    <ChartCard title="Cache Hit Rate" subtitle="Last 24 hours" loading={loading} height={400}>
      <LineChart
        xAxis={[
          {
            data: timestamps,
            scaleType: 'time',
            valueFormatter: (date) =>
              new Date(date).toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }),
          },
        ]}
        yAxis={[
          {
            label: 'Hit Rate (%)',
            min: 75,
            max: 100,
          },
        ]}
        series={[
          {
            data: hitRates,
            label: 'Overall',
            color: '#1976d2',
            showMark: false,
          },
          {
            data: r2HitRates,
            label: 'R2',
            color: '#2e7d32',
            showMark: false,
          },
          {
            data: kvHitRates,
            label: 'KV',
            color: '#ed6c02',
            showMark: false,
          },
        ]}
        grid={{ vertical: false, horizontal: true }}
        sx={{
          '& .MuiLineElement-root': {
            strokeWidth: 2,
          },
        }}
      />
    </ChartCard>
  );
}
